module.exports = __webpack_public_path__ + "media/from-concept-to-visuals.71e2edc1.mp4";